import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { scrollToId } from "@/lib/useLenis";
import { NAV } from "@/constants/testIds";

const LINKS = [
  { label: "About",       to: "/#about",      tid: NAV.linkAbout },
  { label: "Why Cara",    to: "/#why",        tid: NAV.linkWhy },
  { label: "Leadership",  to: "/#leadership", tid: NAV.linkLeadership },
  { label: "Event",       to: "/event",       tid: NAV.linkEvent },
];

export default function Nav({ current = "home" }) {
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  function handleLink(e, to) {
    e.preventDefault();
    const [path, hash] = to.split("#");
    const targetPath = path || "/";
    if (location.pathname === targetPath) {
      if (hash) scrollToId(hash);
      else window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      navigate(to);
    }
  }

  function handleLogo(e) {
    e.preventDefault();
    if (location.pathname === "/") window.scrollTo({ top: 0, behavior: "smooth" });
    else navigate("/");
  }

  function handleRsvp(e) {
    e.preventDefault();
    if (location.pathname === "/event") scrollToId("rsvp");
    else navigate("/event#rsvp");
  }

  return (
    <nav
      data-testid={NAV.wrapper}
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? "nav-glass" : "nav-transparent"
      }`}
    >
      <div className="container-editorial flex items-center justify-between h-16 md:h-20">
        <a
          data-testid={NAV.logo}
          href="/"
          onClick={handleLogo}
          className="no-select flex items-center"
          aria-label="Cara Capital — home"
        >
          <img
            src="/media/cara-logo.png"
            alt="Cara Capital"
            className="h-5 md:h-7 w-auto"
            draggable="false"
          />
        </a>
        <div className="hidden md:flex items-center gap-9">
          {LINKS.map((l) => {
            const isCurrent =
              (l.to === "/event" && current === "event") ||
              (l.to.startsWith("/#") && current === "home" && location.hash === l.to.slice(1));
            return (
              <a
                key={l.to}
                href={l.to}
                data-testid={l.tid}
                onClick={(e) => handleLink(e, l.to)}
                className="text-[13px] tracking-wide"
                style={{
                  color: "var(--ink)",
                  opacity: isCurrent ? 1 : 0.85,
                  fontWeight: isCurrent ? 500 : 400,
                }}
              >
                {l.label}
              </a>
            );
          })}
        </div>
        <a
          data-testid={NAV.rsvpCta}
          href="/event#rsvp"
          onClick={handleRsvp}
          className="btn btn-ember"
          style={{ padding: "10px 18px", fontSize: 12.5 }}
        >
          RSVP
        </a>
      </div>
    </nav>
  );
}
